import React from 'react';
import { FaUsers, FaEdit, FaGlobe, FaDice, FaBookOpen } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import * as S from '../Conecta2ProductPage.styles';

const icons = [FaDice, FaUsers, FaEdit, FaBookOpen, FaGlobe];

const IncludesSection = () => {
  const t = useTranslation();
  const items = t('conecta2Product.includes.items');

  return (
    <S.Section>
      <S.Container>
        <S.SectionTitle>{t('conecta2Product.includes.title')}</S.SectionTitle>
        <S.FeaturesList>
          {items.map((text, index) => {
            const IconComponent = icons[index];
            return (
              <S.FeatureItem key={index}>
                <S.FeatureIcon>
                  <IconComponent />
                </S.FeatureIcon>
                <S.FeatureText>{text}</S.FeatureText>
              </S.FeatureItem>
            );
          })}
        </S.FeaturesList>
      </S.Container>
    </S.Section>
  );
};

export default IncludesSection;
